"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporateUserSchema = void 0;
const identity_user_schema_1 = require("./identity-user.schema");
exports.CorporateUserSchema = identity_user_schema_1.BaseIdentitySchema;
